export default function ProductFilters({
  categories,
  selectedCategory,
  setSelectedCategory,
}) {
  return (
    <div className="flex flex-wrap gap-3">

      <button
        onClick={() => setSelectedCategory("all")}
        className={`
          px-4 py-2 rounded-xl font-medium transition
          ${
            selectedCategory === "all"
              ? "bg-gray-900 text-white"
              : "bg-gray-100 text-gray-700 hover:bg-gray-200"
          }
        `}
      >
        Toutes
      </button>

      {categories.map((category) => (
        <button
          key={category.slug}
          onClick={() =>
            setSelectedCategory(category.slug)
          }
          className={`
            px-4 py-2 rounded-xl font-medium transition
            ${
              selectedCategory === category.slug
                ? "bg-gray-900 text-white"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            }
          `}
        >
          {category.name}
        </button>
      ))}
    </div>
  )
}